import { gql } from '__generated__/gql';
import { ApolloCache } from '@apollo/client';

export const LIST_TASKS = gql(`
  query ListTasks($bookingId: Int, $publicCompanyId: Int, $publicClientId: Int, $hotelId: Int, $useExplicitFilter: Boolean, $status: ETM_TaskStatus, $dueFrom: Date, $dueTo: Date, $assigneeId: Int, $categoryIds: [Int], $skip: Int, $take: Int, $sortColumn: ETM_TaskSortColumn, $sortDirection: ETM_TaskSortDirection) {
    listTasks(bookingId: $bookingId, publicCompanyId: $publicCompanyId, publicClientId: $publicClientId, hotelId: $hotelId, useExplicitFilter: $useExplicitFilter, status: $status, dueFrom: $dueFrom, dueTo: $dueTo, assigneeId: $assigneeId, categoryIds: $categoryIds, skip: $skip, take: $take, sortColumn: $sortColumn, sortDirection: $sortDirection) {
      totalCount
      tasks {
        id
        createdAt
        updatedAt
        description
        dueDate
        status
        priority
        categoryId
        category {
          id
          name
        }
        subjectId
        subject {
          id
          name
        }
        assigneeId
        assignee {
          id
          name
        }
        createdById
        createdBy {
          id
          name
        }
        hotelId
        hotel {
          id
          name
          businessName
        }
        bookingId
        booking {
          id
          title
          refCode
        }
        publicClientId
        publicClient {
          id
          firstname
          lastname
        }
        publicCompanyId
        publicCompany {
         id
         name
         isPremium
        }
        comments {
          id
          comment
          createdAt
          user {
            id
            name
          }
        }
      }
    }
  }
`);

export const VIEW_TASK = gql(`
  query ViewTask($id: Int!) {
    viewTask(id: $id) {
      id
      description
      dueDate
      status
      priority
    }
  }
`);

export const CREATE_TASK = gql(`
  mutation CreateTask($input: TM_TaskInput!) {
    createTask(input: $input) {
      id
      description
      dueDate
      status
      priority
    }
  }
`);

export const UPDATE_TASK = gql(`
  mutation UpdateTask($id: Int!, $input: TM_TaskInput!) {
    updateTask(id: $id, input: $input) {
      id
      description
      dueDate
      status
      priority
    }
  }
`);

export const LIST_TASK_CATEGORIES = gql(`
  query ListTaskCategories {
    listTaskCategories {
      id
      name
      disabled
      system
      groupId
      group {
        id
        name
      }
    }
  }
`);

export const LIST_TASK_CATEGORY_GROUPS = gql(`
  query ListTaskCategoryGroups {
    listTaskCategoryGroups {
      id
      name
      disabled
      system
    }
  }
`);

export const LIST_TASK_SUBJECTS = gql(`
  query ListTaskSubjects {
    listTaskSubjects {
      id
      name
      disabled
      system
      categoryId
      category {
        id
        name
        group {
          id
          name
        }
      }
    }
  }
`);

export const VIEW_TASK_CATEGORY = gql(`
  query ViewTaskCategory($id: Int!) {
    viewTaskCategory(id: $id) {
      id
      name
      disabled
      system
      groupId
    }
  }
`);

export const VIEW_TASK_CATEGORY_GROUP = gql(`
  query ViewTaskCategoryGroup($id: Int!) {
    viewTaskCategoryGroup(id: $id) {
      id
      name
      disabled
      system
    }
  }
`);

export const VIEW_TASK_SUBJECT = gql(`
  query ViewTaskSubject($id: Int!) {
    viewTaskSubject(id: $id) {
      id
      name
      disabled
      system
      descriptionTemplate
      categoryId
    }
  }
`);

export const LIST_TASK_USERS = gql(`
  query ListTaskUsers {
    listTaskUsers {
      id
      name
    }
  }
`);

export const LIST_TASK_HOTELS = gql(`
  query ListTaskHotels {
    listTaskHotels {
      id
      name
      businessName
    }
  }
`);

export const LIST_TASK_BOOKINGS = gql(`
  query ListTaskBookings {
    listTaskBookings {
      id
      title
      refCode
    }
  }
`);

export const LIST_TASK_PUBLIC_CLIENTS = gql(`
  query ListTaskPublicClients {
    listTaskPublicClients {
      id
      firstname
      lastname
      publicCompanyId
    }
  }
`);

export const LIST_TASK_PUBLIC_COMPANIES = gql(`
  query ListTaskPublicCompanies {
    listTaskPublicCompanies {
      id
      name
    }
  }
`);

export const VIEW_TASK_FILTER = gql(`
  query ViewTaskFilter {
    viewTaskFilter {
      status
      dueFrom
      dueTo
      assigneeEmpty
      assignees {
        id
      }
      categories {
        id
      }
      publicCompanies {
        id
      }
      publicClients {
        id
      }
      hotels {
        id
      }
    }
  }
`);

export const UPDATE_TASK_FILTER = gql(`
  mutation UpdateTaskFilter($input: TM_TaskFilterInput!) {
    updateTaskFilter(input: $input) {
      status
    }
  }
`);

export const UPDATE_TASK_CATEGORY = gql(`
  mutation UpdateTaskCategory($id: Int!, $data: TM_TaskCategoryInput!) {
    updateTaskCategory(id: $id, data: $data) {
      id
      name
      disabled
      system
      groupId
    }
  }
`);

export const CREATE_TASK_CATEGORY = gql(`
  mutation CreateTaskCategory($data: TM_TaskCategoryInput!) {
    createTaskCategory(data: $data) {
      id
      name
      disabled
      system
      groupId
    }
  }
`);

export const UPDATE_TASK_CATEGORY_GROUP = gql(`
  mutation UpdateTaskCategoryGroup($id: Int!, $data: TM_TaskCategoryGroupInput!) {
    updateTaskCategoryGroup(id: $id, data: $data) {
      id
      name
      disabled
      system
    }
  }
`);

export const CREATE_TASK_CATEGORY_GROUP = gql(`
  mutation CreateTaskCategoryGroup($data: TM_TaskCategoryGroupInput!) {
    createTaskCategoryGroup(data: $data) {
      id
      name
      disabled
      system
    }
  }
`);

export const UPDATE_TASK_SUBJECT = gql(`
  mutation UpdateTaskSubject($id: Int!, $data: TM_TaskSubjectInput!) {
    updateTaskSubject(id: $id, data: $data) {
      id
      name
      disabled
      system
      descriptionTemplate
      categoryId
    }
  }
`);

export const CREATE_TASK_SUBJECT = gql(`
  mutation CreateTaskSubject($data: TM_TaskSubjectInput!) {
    createTaskSubject(data: $data) {
      id
      name
      disabled
      system
      descriptionTemplate
      categoryId
    }
  }
`);

export const ADD_TASK_COMMENT = gql(`
  mutation AddTaskComment($taskId: Int!, $comment: String!) {
    addTaskComment(taskId: $taskId, comment: $comment) {
      id
      comment
    }
  }
`);

export const UPDATE_TASK_COMMENT = gql(`
  mutation UpdateTaskComment($id: Int!, $comment: String!) {
    updateTaskComment(id: $id, comment: $comment) {
      id
      comment
    }
  }
`);

export const DELETE_TASK_COMMENT = gql(`
  mutation DeleteTaskComment($id: Int!) {
    deleteTaskComment(id: $id) {
      id
    }
  }
`);

// Paged queries for lazy loading dropdowns
export const LIST_TASK_HOTELS_PAGED = gql(`
  query ListTaskHotelsPaged($search: String, $skip: Int, $take: Int) {
    listTaskHotelsPaged(search: $search, skip: $skip, take: $take) {
      hotels {
        id
        name
        businessName
      }
      totalCount
    }
  }
`);

export const LIST_TASK_PUBLIC_COMPANIES_PAGED = gql(`
  query ListTaskPublicCompaniesPaged($search: String, $clientId: Int, $skip: Int, $take: Int) {
    listTaskPublicCompaniesPaged(search: $search, clientId: $clientId, skip: $skip, take: $take) {
      companies {
        id
        name
      }
      totalCount
    }
  }
`);

export const LIST_TASK_PUBLIC_CLIENTS_PAGED = gql(`
  query ListTaskPublicClientsPaged($search: String, $companyId: Int, $skip: Int, $take: Int) {
    listTaskPublicClientsPaged(search: $search, companyId: $companyId, skip: $skip, take: $take) {
      clients {
        id
        firstname
        lastname
        publicCompanyId
        publicCompany {
          id
          name
        }
      }
      totalCount
    }
  }
`);

export const LIST_TASK_USERS_PAGED = gql(`
  query ListTaskUsersPaged($search: String, $skip: Int, $take: Int) {
    listTaskUsersPaged(search: $search, skip: $skip, take: $take) {
      users {
        id
        name
      }
      totalCount
    }
  }
`);

export const LIST_TASK_BOOKINGS_PAGED = gql(`
  query ListTaskBookingsPaged($search: String, $skip: Int, $take: Int) {
    listTaskBookingsPaged(search: $search, skip: $skip, take: $take) {
      bookings {
        id
        title
        refCode
      }
      totalCount
    }
  }
`);

export const GET_BOOKING_FOR_TASK = gql(`
  query GetBookingForTask($id: Int!) {
    viewBooking(id: $id) {
      id
      publicCompanyId
      publicCompany {
        id
        name
      }
      publicClientId
      publicClient {
        id
        firstname
        lastname
      }
      offers {
        hotel {
          id
          name
        }
      }
    }
  }
`);